const mediaOperationServiceName = "/MediaOperation"
export function mediaOperationService(http) {

    return {
        async SaveMedia(data) {
            return await http.post(mediaOperationServiceName + "/SaveMediaFile", data);
        },
        async SaveMedias(data) {
            return await http.post(mediaOperationServiceName + "/SaveMediaFiles", data);
        },
        getFileInformarion(arrayId) {
            let param = {
                "MediaFileIds": arrayId
            }
            return http.post(mediaOperationServiceName + "/GetFilesInformation", param);
        },
        async getPersonnelPhotosAsync(employmentCostCenterCode, firstConfirmer, secondConfirmer) {
            let param = {
                employmentCostCenterCode,
                firstConfirmer, 
                secondConfirmer
            }
            return await http.post(mediaOperationServiceName + "/GetPersonnelPhotosAsync", param);
        },
        deleteMediaFile(arrayId) {
            let param = {
                "MediaFileIds": arrayId
            }
            return http.post(mediaOperationServiceName + "/DeleteMediaFiles", param);
        },
        async ConfirmPersonnelPhotos (mediaFileId, firstConfirmer, secondConfirmer, userProfileId) {
            let param = {
                mediaFileId,
                firstConfirmer, 
                secondConfirmer,
                userProfileId
            }
            return await http.post(mediaOperationServiceName + "/ConfirmPersonnelPhotos", param);
        },
        downloadFiles(filesIdsArray) {
            let param = {
                "MediaFileIds": filesIdsArray
            }
            return http.post(mediaOperationServiceName + "/DownloadMediaFilesBytes", param);
        },
        downloadFilesStream(filesId) {
            let param = {
                "MediaFileId": filesId
            }
            return http.post(mediaOperationServiceName + "/DownloadFileStream", param);
        },
        downloadFile(fileId, open = false) {
            let param = {
                "MediaFileId": fileId,
            };
            return http.post(mediaOperationServiceName + "/DownloadFileStream", param,
                { responseType: "blob" });
        },
        downloadFileStreamByFullPath (path, fileName, fileType, open = false) {
            let param = {
                "Address": path,
                "FileName": fileName,
                "FileType": fileType
            };
            return http.post(mediaOperationServiceName + "/DownloadFileStreamByFullPath", param,
                { responseType: "blob" });
        },
        getGirdData(pageIndex,pageSize,sortBy,filters){
            
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))

            const param = {
                attribute:{
                    page:pageIndex,
                    pageSize,
                    sorts:newSortBy,
                    filter:filters
                }  
            }
            return http.post(mediaOperationServiceName + "/GetGridData", param);
        }
        
    }
}